// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3rzE0","additionalInfo":"AgreementModal_additionalInfo__1eogD"};